declare global {
  interface Window {
    _hsq: any[]
  }
}

export function _trackHsqIdentity(userEmail?: string) {
  console.log('Tracking Hubspot identity for user:', userEmail)

  if (window == null) return
  if (window._hsq == null) {
    return
  }
  if (userEmail == null) return

  console.log('_hsq - identify')
  window._hsq.push([
    'identify',
    {
      email: userEmail,
    },
  ])
  window._hsq.push(['trackPageView'])
}

export function addHubspotScript() {
  const hubspotTrackingNumber = _getHubspotTrackingNumber()
  if (hubspotTrackingNumber == null) return

  const firstPath = window.location.pathname + window.location.search
  window._hsq = window._hsq || []
  window._hsq.push(['setPath', firstPath])
  window._hsq.push(['trackPageView'])

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = 'hs-script-loader'
  script.async = true
  script.defer = true
  script.src = `//js-eu1.hs-scripts.com/${hubspotTrackingNumber}.js`
  document.head.appendChild(script)
}

function _getHubspotTrackingNumber() {
  const hostname = window.location.hostname
  if (hostname === 'app.investinslovakia.eu') return '145915225'
  return null
}
